import React from "react";
import { useState } from "react";
import OtpInput from "react-otp-input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useDeleteAccountMutation } from "../../redux/slices/AccountSlice";
import { useVerifyOtpMutation } from "../../redux/slices/AccountSlice";
import { useDeleteUserMutation } from "../../redux/slices/AccountSlice";
import { useNavigate } from "react-router-dom";
import { faLacrosseStick } from "@fortawesome/pro-light-svg-icons";

import Logo from "../../assets/images/QubioMaster.svg";
import Loader from "../loader";
import Lottie from "lottie-react";
import Lodder from "../loader/Qubio-Spinner-Grey.json";

function DeleteAccount() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");

  const [visible, setVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [otpResponse, setOtpResponse] = useState("");
  const [deletionError, setDeletionError] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [deleteAccount, { isLoading, isError, error, isSuccess }] =
    useDeleteAccountMutation();

  const [verifyOtp, { isError: otpError }] = useVerifyOtpMutation();

  const [deleteUser] = useDeleteUserMutation();

  const handleEmail = (e) => {
    setEmail(e.target.value);
  if (/^[a-zA-Z0-9_+.-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(e.target.value)) {
      setEmailError(false);
      setEmailErrorMessage("");
    } else {
      setEmailError(true);
      setEmailErrorMessage("Enter Valid Email");
    }
    setVisible(false);
  };

  const handleOtp = (e) => {
    setOtp(e.target.value);
    setOtpResponse("");
  };

  const handleDeleteAccount = async () => {
    if (!email) {
      setEmailError(true);
      setEmailErrorMessage("Enter email");
    }
    if (!emailError && email) {
      setLoading(true);
      try {
        const response = await deleteAccount({
          email: email.toLowerCase(),
        }).unwrap();

        if (response.success) {
          setVisible(true);
        }
        setLoading(false);
      } catch (error) {
        if (error.status === 404) {
          setEmailError(true);
          setEmailErrorMessage(error.data?.message);
        }
        setLoading(false);
      }
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp) {
      setOtpResponse("Enter Otp Please");
    }
    if (otp) {
      setLoading(true);
      try {
        const response = await verifyOtp({
          email: email,
          otp: otp,
        }).unwrap();
        if (response.success) {
          try {
            const response = await deleteUser({ email: email }).unwrap();
            setSuccessMessage(response.success);
            setLoading(false);
          } catch (error) {
            setDeletionError(true);
          }
        }
      } catch (error) {
        if (error.status === 404) {
          setOtpResponse(error.data?.message);
        }
        setLoading(false);
      }
    }
  };

  const handleDeletionError = () => {
    window.location.reload();
  };

  const handleResendOtp = async () => {
    try {
      const response = await deleteAccount({
        email: email.toLowerCase(),
      }).unwrap();
    } catch (error) {}
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      {!visible && (
        <div
          className="UserDeleteAccount"
          style={{
            height: "auto",
            backgroundColor: "#ffffff",
            display: "flex",
            flexDirection: "column",

            // margin: "50px auto",
            fontFamily: "Poppins",
            fontWeight: 400,
            gap: "24px",
            padding: "48px 24px",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            color: "#181052",
          }}
        >
          <h3>Delete my Data</h3>
          <p>
            Please enter the email address you use to login to Qubio. All your
            data will be permanently deleted and cannot be recovered.{" "}
          </p>

          <div className="email-controller">
            <div
              style={{
                position: "relative",
              }}
            >
              <input
                type="email"
                className="custom-input"
                style={{
                  border: emailError ? "1px solid red" : "2px solid #8B5CF6",
                  margin: "0px",
                  width: "100%",
                  padding: "18px 12px",
                  fontSize: "16px",
                }}
                placeholder="youremail@site.com"
                onChange={handleEmail}
              />

              <label className="custom-label">Email Address</label>
              {emailError && (
                <span
                  style={{
                    color: "#F43F5E",
                    fontSize: "12px",
                    fontFamily: "Poppins",
                    margin: "0px",
                    gap: "0px",
                  }}
                >
                  {emailErrorMessage}
                </span>
              )}
            </div>
          </div>

          <button
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "18px 12px",
              borderRadius: "8px",
              border: "2px solid #6B7280",
              backgroundColor: "#FFFFFF",
              cursor: "pointer",
              position: "relative",
            }}
            onClick={handleDeleteAccount}
          >
            {!loading ? (
              <>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                  }}
                >
                  Delete Data
                </span>
                <FontAwesomeIcon
                  icon="fa-sharp fa-solid fa-chevron-right"
                  style={{
                    fontSize: "16px",
                  }}
                />{" "}
              </>
            ) : (
              <div
                style={{
                  margin: "0px 50%",
                }}
              >
                <Lottie
                  animationData={Lodder}
                  style={{
                    width: "24px",
                    height: "24px",
                  }}
                />
              </div>
            )}
          </button>
        </div>
      )}

      {visible & !successMessage ? (
        <div
          style={{
            width: "50%",
            height: "auto",
            backgroundColor: "#ffffff",
            display: "flex",
            flexDirection: "column",
            margin: "50px auto",
            fontFamily: "Poppins",
            fontWeight: 400,
            gap: "24px",
            padding: "48px 24px",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            color: "#181052",
          }}
        >
          <h3>Verification</h3>
          <p>
            Please enter the verification code sent to <b>{email}</b> <br />{" "}
            Didn’t get it?{" "}
            <span
              style={{
                textDecorationLine: "underline",
                cursor: "pointer",
              }}
              onClick={handleResendOtp}
            >
              Resend
            </span>
          </p>

          <div className="email-controller">
            <div
              style={{
                position: "relative",
              }}
            >
              <input
                type="text"
                className="custom-input"
                style={{
                  border: otpResponse
                    ? "2px solid #F43F5E"
                    : "2px solid #8B5CF6",
                  margin: "0px",
                  width: "100%",
                  padding: "18px 12px",
                }}
                placeholder="123456"
                onChange={handleOtp}
              />

              <label
                className="custom-label"
                style={{
                  color: otpResponse && "#F43F5E",
                }}
              >
                Verification Code
              </label>
              {otpResponse && (
                <span
                  style={{
                    color: "#F43F5E",
                    fontSize: "12px",
                    fontFamily: "Poppins",
                    margin: "0px",
                    gap: "0px",
                  }}
                >
                  {otpResponse}
                </span>
              )}
            </div>
          </div>

          <button
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "18px 12px",
              borderRadius: "8px",
              border: "2px solid #6B7280",
              backgroundColor: "#FFFFFF",
              cursor: "pointer",
            }}
            onClick={handleVerifyOtp}
          >
            {!loading ? (
              <>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                  }}
                >
                  Submit
                </span>
                <FontAwesomeIcon
                  icon="fa-sharp fa-solid fa-chevron-right"
                  style={{
                    fontSize: "16px",
                  }}
                />{" "}
              </>
            ) : (
              <div
                style={{
                  margin: "0px 50%",
                }}
              >
                <Lottie
                  animationData={Lodder}
                  style={{
                    width: "24px",
                    height: "24px",
                  }}
                />
              </div>
            )}
          </button>
        </div>
      ) : null}
      {visible & successMessage ? (
        <div
          style={{
            width: "50%",
            height: "auto",
            backgroundColor: "#ffffff",
            display: "flex",
            flexDirection: "column",
            margin: "50px auto",
            fontFamily: "Poppins",
            fontWeight: 400,
            gap: "24px",
            padding: "48px 24px",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            color: "#181052",
          }}
        >
          <h3>Success</h3>
          <p>
            Your submission has been received and deletion of your data has
            commenced.
          </p>
        </div>
      ) : null}

      {visible & deletionError ? (
        <div
          style={{
            width: "50%",
            height: "auto",
            backgroundColor: "#ffffff",
            display: "flex",
            flexDirection: "column",
            margin: "50px auto",
            fontFamily: "Poppins",
            fontWeight: 400,
            gap: "24px",
            padding: "48px 24px",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            color: "#181052",
          }}
        >
          <h3>Error</h3>
          <p>
            An error has occurred while submitting the request. Please wait a
            while and try again.
          </p>

          <button
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "18px 12px",
              borderRadius: "8px",
              border: "2px solid #6B7280",
              backgroundColor: "#FFFFFF",
              cursor: "pointer",
            }}
            onClick={handleDeletionError}
          >
            <span
              style={{
                fontFamily: "Poppins",
              }}
            >
              Go Back
            </span>
            <FontAwesomeIcon
              icon="fa-sharp fa-solid fa-chevron-right"
              style={{
                fontSize: "16px",
              }}
            />
          </button>
        </div>
      ) : null}

      <img src={Logo} style={{ width: "80px", height: "80px" }} />
    </div>
  );
}

export default DeleteAccount;
